import { FunctionComponent, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { TooltipWrapper } from "../../../../../components/Shared/Components/TooltipWrapper/TooltipWrapper";
import { translationKeys } from "../../../../../models/app-translation-keys";
import { useStore } from "../../../../../stores/StoreContext";

import "./Separator.scss";

interface ISeparatorProps {
  separatorKey?: string;
  isUserSeparator?: boolean;
}

const RawSeparator: FunctionComponent<ISeparatorProps> = (props: ISeparatorProps) => {
  const { t } = useTranslation();
  const { userStore } = useStore();

  const prefix = useRef<string>("sidebarThreads.separators.");
  const elementRef = useRef<HTMLDivElement>(null);

  const separatorMemo = useMemo(() => {
    if (props.isUserSeparator) {
      return t(translationKeys.userThreadSeparator.long);
    }

    const currYear: string = new Date().getFullYear().toString();
    if (props.separatorKey === "currentYear" || props.separatorKey === "beforeCurrentYear") {
      return t(`${prefix.current}${props.separatorKey}`) + " " + currYear;
    } else {
      return t(`${prefix.current}${props.separatorKey}.long`);
    }
  }, [props.separatorKey, props.isUserSeparator, userStore.currentLanguage]);

  return (
    <div className="thread-separator" ref={elementRef}>
      <TooltipWrapper
        targetRef={elementRef}
        mouseTrack
        mouseTrackLeft={10}
        content={separatorMemo}
        showDelay={500}
        hideDelay={200}
      />

      {separatorMemo}
    </div>
  );
};

export const Separator = observer(RawSeparator);
